import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { LoadingBackDrop } from "../../../components/loader";
import { theme } from "../../../helpers/theme";
import { getOrdersPricelistOffersById } from "../../../services/orders/pricelist-offers-get-by-id";
import {
  PricelistOffersGetByIdOffers,
  PricelistOffersGetByIdPayload,
} from "../../../services/orders/pricelist-offers-get-by-id/types";
import SessionService from "../../../services/session-service";
import { OfferViewContent } from "./components/offer-view-content";
import { DecisionArea } from "./components/offer-view-content/decision-area";
import { Footnotes } from "./components/offer-view-content/footnotes";
import {
  offerPrice,
  OfferSummary,
} from "./components/offer-view-content/price-for-offer";
import { OfferViewHeader } from "./components/offer-view-header";
import { OfferViewWarehouseAddress } from "./components/offer-view-warehouse-address";
import { TyperOfOffer } from "./components/type-of-offer";
import { ConsultationAndIndividualProcing } from "./components/view-variants/consultation-and-individual-pricing";
import { NoMatchingWarehouses } from "./components/view-variants/no-matching-warehouses";
import { OfferTrailer } from "./components/offer-trailer";

import {
  ArrayOfPrice,
  IsPriceVisible,
  OffersSelectionView,
  SumInButtonChangeTypeOfWarehouse,
  TwoTypesOfOfferHandler,
} from "./helpers/types";
import { Divider } from "@mui/material";
import { string } from "yup/lib/locale";
import { ordersPricelistMoq } from "../offer-view-from-email/helpers/maq-data";
import { FinalOfferLabel } from "./components/final-offer-label";
import { getAllWarehouses } from "../../../services/warehouses/get-all";
import { warehouses } from "../../../redux/actions";
import { useAppDispatch } from "../../../hooks/redux-hooks";

interface OfferViewProps {
offer_id_from_email?:string,
data?:PricelistOffersGetByIdPayload,
isFinalOffer?:boolean,
token24?:string,
}


export const OfferView = ({offer_id_from_email,data,isFinalOffer,token24}:OfferViewProps) => {
  // Ułożenie listy na podział dwu argumentowy
  // 0-magazyn dedykowany
  // 1-multimagazyn

  //const ordersPricelistMoq:PricelistOffersGetByIdPayload=data;

  const user = SessionService.getUser();
  const isLoged = user && user.token_dostepu !== null ? true : false;
  const dispatch = useAppDispatch();
  
  const [ordersPricelist, setOrdersPricelist] =
    useState<PricelistOffersGetByIdPayload>();
  const [dataDividedIntoRwoCategories, setDataDividedIntoRwoCategories] =
    useState<OffersSelectionView>();
  const [isTwoTypesOfOffer, setIsTwoTypesOfOffer] =
    useState<TwoTypesOfOfferHandler>({
      twoTypesOfOfferHandler: false,
      active: 1, //-1- obie nieaktywne,2-obie aktywne
    });
  const [isMultiWarehouseDisable, setIsMultiWarehouseDisable] = useState(false);
  const [isDedicateWarehouseDisable, setIsDedicateWarehouseDisable] =
    useState(false);
  const [activeTypeOfOffer, setActiveTypeOfOffer] = useState(1); //Przyjęta wartość startowa 1 możliwe  [0,1]
  const [activeData, setActiveData] =
    useState<PricelistOffersGetByIdOffers[]>();
  const [buttonSumData, setButtonSumData] = useState<ArrayOfPrice[]>([]);
  const [
    isComponentNoMatchingWarehousesVisible,
    setIsComponentNoMatchingWarehousesVisible,
  ] = useState(false);
  const [
    isComponentConsultationAndIndividualProcing,
    setIsComponentConsultationAndIndividualProcing,
  ] = useState(true);
  const [isPriceVisible, setIsPriceVisible] = useState<IsPriceVisible>({
    value_dedicate_warehouse: true,
    value_multi_warehouse: true,
  });

  const [isButtonTypeVisible, setIsButtonTypeVisible] = useState(true);
  const [value_dedicate_warehouse, setValue_dedicate_warehouse] = useState<
    SumInButtonChangeTypeOfWarehouse | undefined
  >();
  const [value_multi_warehouse, setValue_multi_warehouse] = useState<
    SumInButtonChangeTypeOfWarehouse | undefined
  >();
  const [expanded, setExpanded] = useState<string | false>(false);
  
  const body = {
    paginacja: null,
  };

const getAllWarehousesClient = useQuery(
    ["warehouses"],
    () => getAllWarehouses(body),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        dispatch(warehouses.fetchAllWarehouses(data.data.payload.magazyny));
        SessionService.setWarehousesList(data.data.payload.magazyny);
      },
    }
  );
  const GetOrdersPricelistOffers = useQuery(
    ["OrdersPricelistOffers"],
    () =>
      getOrdersPricelistOffersById({
        id_zamowienie: offer_id_from_email?offer_id_from_email: SessionService.getOrderIdentification().id_zamowienie,
        token: token24
        ?token24
        :(isLoged ? null : SessionService.getTokenForUnlogedClient().token),

      }),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(res) {
        if (res.data.payload) {
      
          setOrdersPricelist(data
            ?data
            :res.data?.payload);
          setDataDividedIntoRwoCategories(
            divisionIntoTwoTypesOffer(
              data
              ?data.oferty
              :res.data?.payload.oferty
              )
          );
          setIsTwoTypesOfOffer(
            twoTypesOfOfferHandler(
              data
              ?data.oferty
              :res.data?.payload.oferty)
          );
       
          // console.log("OBIERANIE DANYCH");
          // setOrdersPricelist(ordersPricelistMoq);
          // setDataDividedIntoRwoCategories(divisionIntoTwoTypesOffer(ordersPricelistMoq.oferty));
          // setIsTwoTypesOfOffer(twoTypesOfOfferHandler(ordersPricelistMoq.oferty));
        }
      },
    }
  );

  const twoTypesOfOfferHandler = (
    offer: PricelistOffersGetByIdOffers[] | undefined
  ): TwoTypesOfOfferHandler => {
    let zero: number = 0;
    let one: number = 0;
    let result: TwoTypesOfOfferHandler = {
      twoTypesOfOfferHandler: false,
      active: 1, //-1- obie nieaktywne,2-obie aktywne
    };
    offer?.map((offer: PricelistOffersGetByIdOffers) => {
      if (offer.rodzaj_oferty === 0) {
        zero = 1;
      } else {
        one = 1;
      }
    });

    if (zero === 1 && one === 1) {
      result = {
        twoTypesOfOfferHandler: true,
        active: 2,
      };
      //setActiveTypeOfOffer(1);
    } else if (zero === 1 && one === 0) {
      result = {
        twoTypesOfOfferHandler: false,
        active: 0,
      };
      setActiveTypeOfOffer(0);
    } else if (zero === 0 && one === 1) {
      result = {
        twoTypesOfOfferHandler: false,
        active: 1,
      };
      setActiveTypeOfOffer(1);
    } else {
      result = {
        twoTypesOfOfferHandler: false,
        active: -1,
      };
    }

    setIsTwoTypesOfOffer(result);

    return result;
  };
  const divisionIntoTwoTypesOffer = (
    offer: PricelistOffersGetByIdOffers[] | undefined
  ): OffersSelectionView => {
    let ZeroArray_dedicated: PricelistOffersGetByIdOffers[] = [];
    let OneArray_multimagazyn: PricelistOffersGetByIdOffers[] = [];
    let result: OffersSelectionView;

    if (offer) {
      offer?.map((offer: PricelistOffersGetByIdOffers) => {
        if (offer.rodzaj_oferty === 0) {
          ZeroArray_dedicated.push(offer);
        } else {
          OneArray_multimagazyn.push(offer);
        }
      });
    } else {
      ZeroArray_dedicated = [];
      OneArray_multimagazyn = [];
    }

    result = {
      ZeroArray_dedicated: ZeroArray_dedicated,
      OneArray_multimagazyn: OneArray_multimagazyn,
    };

    result = checkOfferStatusAndDecision(result);
    return result;
  };
  const checkOfferStatusAndDecision = (data: OffersSelectionView) => {
    let _multi_data: PricelistOffersGetByIdOffers[] = [];
    let multi_data: PricelistOffersGetByIdOffers[] = [];
    let error_seven_message_multi_data: PricelistOffersGetByIdOffers[] = [];
    let error_one_message_multi_data: PricelistOffersGetByIdOffers[] = [];
    let _dedicate_data: PricelistOffersGetByIdOffers[] = [];
    let dedicate_data: PricelistOffersGetByIdOffers[] = [];
    let error_seven_message_dedicate_data: PricelistOffersGetByIdOffers[] = [];
    let error_one_message_dedicate_data: PricelistOffersGetByIdOffers[] = [];

    if (data.OneArray_multimagazyn.length > 0) {
      data.OneArray_multimagazyn.map((offer, index) => {
        if (offer.status_oferty !== 7 && offer.status_oferty !== 1) {
          multi_data.push(offer);
        }
        if (offer.status_oferty === 7) {
          error_seven_message_multi_data.push(offer);
        }
        if (offer.status_oferty === 1) {
          error_one_message_multi_data.push(offer);
        }
      });
    }

    if (data.ZeroArray_dedicated.length > 0) {
      data.ZeroArray_dedicated.map((offer, index) => {
        if (offer.status_oferty !== 7 && offer.status_oferty !== 1) {
          dedicate_data.push(offer);
        }
        if (offer.status_oferty === 7) {
          error_seven_message_dedicate_data.push(offer);
        }
        if (offer.status_oferty === 1) {
          error_one_message_dedicate_data.push(offer);
        }
      });
    }

    if (multi_data.length > 0 && dedicate_data.length > 0) {
      setIsPriceVisible({
        value_dedicate_warehouse: true,
        value_multi_warehouse: true,
      });
      setIsButtonTypeVisible(true);
      setIsTwoTypesOfOffer({
        twoTypesOfOfferHandler: true,
        active: 2,
      });
      setIsComponentNoMatchingWarehousesVisible(false);
      setIsComponentConsultationAndIndividualProcing(false);
      return (data = {
        OneArray_multimagazyn: multi_data,
        ZeroArray_dedicated: dedicate_data,
      });
    }

    if (
      multi_data.length === 0 &&
      dedicate_data.length == 0 &&
      data.OneArray_multimagazyn.length + data.ZeroArray_dedicated.length > 0
    ) {
      //Rozgraniczenie na dwa przypadki
      //1) Wina samych błedów 7
      //2) Wina samych błędów 1 oraz Mix błędów

      setIsButtonTypeVisible(false);
      setIsTwoTypesOfOffer({
        twoTypesOfOfferHandler: false,
        active: -1,
      });

      //AD1
      if (
        error_one_message_dedicate_data.length === 0 &&
        error_one_message_multi_data.length === 0 &&
        (error_seven_message_multi_data.length > 0 ||
          error_seven_message_dedicate_data.length > 0)
      ) {
        setIsComponentNoMatchingWarehousesVisible(true);
        setIsComponentConsultationAndIndividualProcing(false);

        return (data = {
          OneArray_multimagazyn: [],
          ZeroArray_dedicated: [],
        });
      }
      //AD2
      else {
        setIsComponentNoMatchingWarehousesVisible(false);
        setIsComponentConsultationAndIndividualProcing(true);

        return (data = {
          OneArray_multimagazyn: [],
          ZeroArray_dedicated: [],
        });
      }
    }

    if (multi_data.length === 0 && data.OneArray_multimagazyn.length > 0) {
      //Dwa warianty
      //1) W multimagazynie jest oferta z 7
      //2) W multimagazynie jest oferta z 1 lub 1 i 7

      setIsButtonTypeVisible(true);

      setIsPriceVisible({
        value_dedicate_warehouse: true,
        value_multi_warehouse: false,
      });

      setIsTwoTypesOfOffer({
        twoTypesOfOfferHandler: true,
        active: 0,
      });
      setIsComponentNoMatchingWarehousesVisible(false);
      setIsComponentConsultationAndIndividualProcing(false);
      //AD1
      if (
        error_seven_message_multi_data.length > 0 &&
        error_one_message_multi_data.length === 0
      ) {
        setIsMultiWarehouseDisable(true);
        setActiveTypeOfOffer(0);
        return (data = {
          OneArray_multimagazyn: [],
          ZeroArray_dedicated: dedicate_data,
        });
      }
      //AD2
      else {
        setIsMultiWarehouseDisable(false);
        return (data = {
          OneArray_multimagazyn: [error_one_message_multi_data[0]],
          ZeroArray_dedicated: dedicate_data,
        });
      }
    }

    if (dedicate_data.length === 0 && data.ZeroArray_dedicated.length > 0) {
      //Dwa warianty
      //1) W dedykowanym jest oferta z 7
      //2) W dedykowanym jest oferta z 1 lub 1 i 7

      setIsButtonTypeVisible(true);
      setIsPriceVisible({
        value_dedicate_warehouse: false,
        value_multi_warehouse: true,
      });

      setIsTwoTypesOfOffer({
        twoTypesOfOfferHandler: true,
        active: 0,
      });
      setIsComponentNoMatchingWarehousesVisible(false);
      setIsComponentConsultationAndIndividualProcing(false);
      //AD1
      if (
        error_seven_message_dedicate_data.length > 0 &&
        error_one_message_dedicate_data.length === 0
      ) {
        setIsDedicateWarehouseDisable(true);
        setActiveTypeOfOffer(1);
        return (data = {
          OneArray_multimagazyn: multi_data,
          ZeroArray_dedicated: [],
        });
      }
      //AD2
      else {
        setIsDedicateWarehouseDisable(false);
        return (data = {
          OneArray_multimagazyn: multi_data,
          ZeroArray_dedicated: [error_one_message_dedicate_data[0]],
        });
      }
    } else {
      setIsComponentNoMatchingWarehousesVisible(false);
      setIsComponentConsultationAndIndividualProcing(false);
      setIsButtonTypeVisible(true);
    }

    return (data = {
      OneArray_multimagazyn:
        multi_data.length === 0 && _multi_data.length > 0
          ? _multi_data
          : multi_data,
      ZeroArray_dedicated:
        dedicate_data.length === 0 && _dedicate_data.length > 0
          ? _dedicate_data
          : dedicate_data,
    });
  };
  const PriceArray = (
    data: OffersSelectionView,
    setValue_dedicate_warehouse: (
      value_dedicate_warehouse: SumInButtonChangeTypeOfWarehouse
    ) => void,
    setValue_multi_warehouse: (
      value_multi_warehouse: SumInButtonChangeTypeOfWarehouse
    ) => void
  ): ArrayOfPrice[] => {
    if (data) {
      let suma: number;
      let requires_consultation: boolean;
      let result: ArrayOfPrice[] = [];

      let result_: ArrayOfPrice[] = [];
      let _suma: number;

      if (data.ZeroArray_dedicated.length > 0) {
        data.ZeroArray_dedicated?.map((offer) => {
          _suma = 0;
          offer.oferty_podwykonawcy.map((subcontractor) => {
            suma = 0;
            requires_consultation = false;
            subcontractor.pozycje_oferty.map((part_of_offer) => {
              suma +=
                part_of_offer.cena_docelowa === null
                  ? 0
                  : part_of_offer.cena_docelowa;
              //suma += part_of_offer.cena_docelowa;
              requires_consultation = part_of_offer.wymaga_wyceny
                ? true
                : requires_consultation;
            });
            result.push({
              warehouse_type: 0,
              offer_id: offer.id_oferta,
              id_of_the_subcontractors_offer:
                subcontractor.id_oferta_podwykonawcy,
              suma: suma,
              requires_consultation: requires_consultation,
            });
            _suma += suma;
          });

          result_.push({
            warehouse_type: 0,
            offer_id: offer.id_oferta,
            suma: _suma,
            requires_consultation: requires_consultation,
          });
        });
      }
      if (data.OneArray_multimagazyn.length > 0) {
        data.OneArray_multimagazyn?.map((offer) => {
          _suma = 0;
          offer.oferty_podwykonawcy.map((subcontractor) => {
            suma = 0;
            requires_consultation = false;
            subcontractor.pozycje_oferty.map((part_of_offer) => {
              suma +=
                part_of_offer.cena_docelowa === null
                  ? 0
                  : part_of_offer.cena_docelowa;
              //suma += part_of_offer.cena_docelowa;
              requires_consultation = part_of_offer.wymaga_wyceny
                ? true
                : requires_consultation;
            });
            result.push({
              warehouse_type: 1,
              offer_id: offer.id_oferta,
              id_of_the_subcontractors_offer:
                subcontractor.id_oferta_podwykonawcy,
              suma: suma,
              requires_consultation: requires_consultation,
            });
            _suma += suma;
          });
          result_.push({
            warehouse_type: 1,
            offer_id: offer.id_oferta,
            suma: _suma,
            requires_consultation: requires_consultation,
          });
        });
      }
      FindMinMaxValue(
        result_,
        setValue_dedicate_warehouse,
        setValue_multi_warehouse
      );
      return result_;
    } else {
      return [];
    }
  };
  const FindMinMaxValue = (
    data: ArrayOfPrice[],
    setValue_dedicate_warehouse: (
      value_dedicate_warehouse: SumInButtonChangeTypeOfWarehouse
    ) => void,
    setValue_multi_warehouse: (
      value_multi_warehouse: SumInButtonChangeTypeOfWarehouse
    ) => void
  ): void => {
    if (data) {
      let price_one: number[] = [];
      let requires_consultation_one: boolean = false;
      let price_zero: number[] = [];
      let requires_consultation_zero: boolean = false;

      let zero_data: SumInButtonChangeTypeOfWarehouse;
      let one_data: SumInButtonChangeTypeOfWarehouse;

      data.map((offer) => {
        if (offer.warehouse_type === 0) {
          price_zero.push(offer.suma);
          requires_consultation_zero = offer.requires_consultation
            ? true
            : requires_consultation_zero;
        }
        if (offer.warehouse_type === 1) {
          price_one.push(offer.suma);
          requires_consultation_one = offer.requires_consultation
            ? true
            : requires_consultation_one;
        }
      });

      zero_data = {
        min_value: Math.min(...price_zero),
        max_value: Math.max(...price_zero),
        requires_consultation: requires_consultation_zero,
      };
      one_data = {
        min_value: Math.min(...price_one),
        max_value: Math.max(...price_one),
        requires_consultation: requires_consultation_one,
      };
      setValue_dedicate_warehouse(zero_data);
      setValue_multi_warehouse(one_data);
    }
  };

  useEffect(() => {
    if (dataDividedIntoRwoCategories) {
      if (dataDividedIntoRwoCategories.OneArray_multimagazyn[0]) {
        setActiveData(dataDividedIntoRwoCategories.OneArray_multimagazyn);
      } else setActiveData(dataDividedIntoRwoCategories.ZeroArray_dedicated);
    }

    dataDividedIntoRwoCategories &&
      setButtonSumData(
        PriceArray(
          dataDividedIntoRwoCategories,
          setValue_dedicate_warehouse,
          setValue_multi_warehouse
        )
      );
  }, [dataDividedIntoRwoCategories]);

  useEffect(() => {
    setActiveData(
      activeTypeOfOffer === 1
        ? dataDividedIntoRwoCategories?.OneArray_multimagazyn
        : dataDividedIntoRwoCategories?.ZeroArray_dedicated
    );
  }, [
    activeTypeOfOffer,
    isComponentNoMatchingWarehousesVisible,
    isComponentConsultationAndIndividualProcing,
    expanded,
  ]);

  useEffect(() => {
    setIsTwoTypesOfOffer(twoTypesOfOfferHandler(ordersPricelist?.oferty));
  }, [
    ordersPricelist,
    dataDividedIntoRwoCategories,
    activeTypeOfOffer,
    activeData,
  ]);

  const handleButtonChangeActiveTypeOfOfferClick = (value: number) => {
    //0 magazyn dedykowany,
    //1 multimagazyn
    if (value === 0) {
      setActiveTypeOfOffer(0);
      setActiveData(dataDividedIntoRwoCategories?.ZeroArray_dedicated);
    } else {
      setActiveTypeOfOffer(1);
      setActiveData(dataDividedIntoRwoCategories?.OneArray_multimagazyn);
    }
  };

  if (
    GetOrdersPricelistOffers.isLoading ||
    GetOrdersPricelistOffers.isRefetching ||
    ordersPricelist === undefined ||
    activeData === undefined
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <PageContainer isLoged={isLoged}>
      {ordersPricelist.oferty?.length > 0 ? (
        <>
          {" "}
          {isButtonTypeVisible ? (
            <>
              <OfferViewHeader
                offer_number_label={"Zamówienie nr"}
                offer_number={ordersPricelist.numer_zamowienia}
              />

              <TyperOfOffer
                type_of_offer={activeTypeOfOffer}
                isMultiWarehouseDisable={isMultiWarehouseDisable}
                isDedicateWarehouseDisable={isDedicateWarehouseDisable}
                value_dedicate_warehouse={value_dedicate_warehouse}
                value_multi_warehouse={value_multi_warehouse}
                handleClik={handleButtonChangeActiveTypeOfOfferClick}
                isTwoTypesOfOffer={isTwoTypesOfOffer}
                isPriceVisible={isPriceVisible}
              />
            </>
          ) : null}
          {activeData ? (
            isComponentNoMatchingWarehousesVisible ? (
              <NoMatchingWarehouses />
            ) : isComponentConsultationAndIndividualProcing ? (
              <ConsultationAndIndividualProcing />
            ) : null
          ) : null}
          {activeData.map((offerta, index) => (
            <div key={index}>
              {offerta.status_oferty === 7 || offerta.status_oferty === 1 ? (
                offerta.status_oferty === 7 ? (
                  <NoMatchingWarehouses />
                ) : (
                  <ConsultationAndIndividualProcing />
                )
              ) : (
                <>
                {/* {isFinalOffer? <FinalOfferLabel/>:null} */}
                <div key={`${offerta.id_oferta}`}>
                  <OfferTrailer
                    index={index}
                    setExpanded={setExpanded}
                    expanded={expanded}
                    offer_id={offerta.id_oferta}
                    value={Number(
                      offerPrice(offerta.oferty_podwykonawcy, offerta.id_oferta)
                        .sum
                    )}
                  />
                  <OfferDetails isVisible={expanded === offerta.id_oferta}>
                    <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
                    {offerta.oferty_podwykonawcy.map((subcontractorOffer) => (
                      <div
                        key={`${offerta.id_oferta}_${subcontractorOffer.id_magazyn}`}
                        style={{ marginTop: "32px" }}
                      >
                        <OfferViewWarehouseAddress
                          id_warehouse={subcontractorOffer.id_magazyn}
                          id_offerta={offerta.id_oferta}
                        />
                        <OfferViewContent
                          subcontractorOffer={subcontractorOffer}
                          pozycje_oferty={subcontractorOffer.pozycje_oferty}
                          id_zamowienia={ordersPricelist.id_zamowienie}
                          additional_services_quantity={
                            ordersPricelist.uslugi_zamowione.ilosc_dodatkowych
                          }
                          oferta_id={offerta.id_oferta}
                        />
                      </div>
                    ))}
                    <OfferSummary
                      oferty_podwykonawcy={offerta.oferty_podwykonawcy}
                      oferta_id={offerta.id_oferta}
                    />
                    <DecisionArea
                      id_zamowienia={ordersPricelist.id_zamowienie}
                      oferta_id={offerta.id_oferta}
                      isFinalOffer={isFinalOffer}
                    />

                    {isButtonTypeVisible ? <Footnotes isFinalOffer={isFinalOffer}/> : null}
                  </OfferDetails>
                </div>
                </>
              )}
            </div>
          ))}
        </>
      ) : (
        <NoMatchingWarehouses />
      )}
    </PageContainer>
  );
};

const PageContainer = styled.div<{
  isLoged: boolean;
}>`
  ${(props: any) =>
    props.isLoged
      ? `
     padding: 20px 10px;
     display: flex;
     flex-direction: column;
     @media (min-width: 1025px) {
      max-width: 1400px;
      margin-left: 225px;
      margin-right: 50px;
    }
    `
    : 
    `
    margin:auto auto;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    max-width: 1400px;
    margin:auto auto;
  `
}`;
const OfferInfo = styled.div`
  color: ${theme.colors.blue01_active};
`;
const OfferDetails = styled.div<{
  isVisible: boolean;
}>`
  background-color: #f2f2f2;
  display: ${(props: any) => (props.isVisible ? "box" : "none")};
  margin-top: ${(props: any) => (props.isVisible ? "-16px" : "none")};
  border: 2px solid #f2f2f2;
  border-top: none;
  padding: 20px 16px;
  margin-bottom: 30px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  transition-duration: 4s;
  -webkit-transition-duration: 10s;
  transition-timing-function: linear;
  & .target {
    background-color: #f2f2f2;
  }
`;
